<template>
  <!-- <keep-alive :include="cachedComponents"> -->
  <router-view />
  <!-- </keep-alive> -->
</template>
<script lang="ts">
import { defineComponent } from 'vue'





export default defineComponent({
  name: 'EmptyRouterParent',
  data() {
    return {
      cachedComponents: ['CustomersPage', 'LeadsPage']
    }
  }
})
</script>
